import React from "react"

import {
  useStyle 
} from "@/classify"

import defaultClasses from "./googleReCaptcha.module.css"

/**
 * A component to display a Google ReCaptcha V3 inline widget.
 *
 * @typedef GoogleReCaptcha
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a container to be used by the useGoogleReCaptcha hook.
 */
const GoogleReCaptcha = (props) => {
  const {
    containerElement = () => {}, shouldRender = false 
  } = props
  const classes = useStyle(defaultClasses, props.classes)

  // Do not display if position is not inline
  if (!shouldRender) {
    return null
  }

  return <div ref={containerElement} className={classes.root} />
}

export default GoogleReCaptcha
